<div class="outer-content">
  <div class="float-left bg-white card-background wh-auto">
    <form [formGroup]="userForm" autocomplete="off" role="form" class="fieldHeight">
      <app-content-top-nav [visibleSaveProgress]="!isHOView"
        [enableBackNav]='!editMode || (editMode && referenceNumber && referenceNumber.isRefreshCard)'
        [visibleBackNav]='true'>
      </app-content-top-nav>
      <div [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant'? 'col-md-12 clear-all dep-title-wrapper':'col-md-12 clear-all title-wrapper'">   
        <h1 class="title-text med-title responsive-text-8" id="medical-condition-header">{{contentData.header}}</h1>
      </div>

      <div class="row margin-left-18">
        <div class="col-md-12 if-you-or-your-depen">
          <span id="medical-condition-helpText" [innerHTML]="headerText"></span>
          <div [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant' && !isDataPresent ? 'info-dependant' : 'info-annuitant'">
            <ng-container *ngIf="deviceType == 'large'; else mobileTooltip;">
              <app-tool-tip-notification [childId]="'medical-condition-info-tooltip'"
              [tooltipData]="medicalConditionConfig">
              </app-tool-tip-notification>
            </ng-container>
            <ng-template #mobileTooltip>
              <app-tool-tip-notification [childId]="'medical-condition-info-tooltip'"
              [tooltipData]="medicalConditionConfig" (medCondnInfoEmitter)="medCondnInfoReceiver($event)">
              </app-tool-tip-notification>
            </ng-template>                        
          </div>
        </div>
      </div>
      <div class="col-md-12" [ngClass]="{'new-bgStyle' : isDataPresent === false, 'bgStyle' : isDataPresent === true}">
        <p [ngClass]="{'new-noteStyle' : isDataPresent === false, 'noteStyle' : isDataPresent === true}"
          id="medicalConditionStatement" [innerHTML]="notifStatement"></p>
      </div>
      <div class="col-md-12 margin-top-30">
        <span class="header" id="medical-conditionTitle">{{contentData.subTitle}}</span>
      </div>
      <ng-container *ngIf="medCondListForDashboard.length > 0">
        <div  class="d-view">
        <div class="col-md-12 ml-40">
          <div class="tableheaders1  col-md-4">
            <span>{{contentData.tableHeader1}}</span>
          </div>
          <div class="tableheaders2 col-md-4">
            <span>{{contentData.tableHeader2}}</span>
          </div>
          <div class="col-md-4"></div>
        </div>
        <div class="col-md-12 underline tableBg" *ngFor="let item of medCondListForDashboard; let i = index">
          <div *ngIf="i === 0" class="underlineStyle"> </div>
          <div class="row">
            <div class="col-md-4">
              <div class="Content1">
                <span class="Cell-content">{{item.mcName}}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="Content3">
                <span class="Cell-content">{{item.status}}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="Content2">
                <i class="icon icon-bin delete-icon reflect" alt="" (keyup.enter)="delete(item)" tabindex="0"
                  (click)="delete(item)" aria-hidden="true"></i>

                <a class="reflect" (keyup.enter)="editMedicalCondition(item)" (click)="editMedicalCondition(item)"
                  tabindex="0" role="button">
                  <span class="linkstyle2">Edit</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-container>

      <ng-container *ngIf="medCondListForDashboard.length > 0">
        <div  class="mt-view">          
          <div class="card-container">
            <div class="card" *ngFor="let item of medCondListForDashboard; let i = index">
              <div class="flex-card-container">
                <div class="medical-condition row-seperator">
                  <span class="card-header-font">{{contentData.tableHeader1}}</span>
                  <span class="card-content-font">{{item.mcName}}</span>
                </div>
                <div class ="status-content row-seperator">
                  <span class="card-header-font">{{contentData.tableHeader2}}</span>
                  <span class="card-content-font">{{item.status}}</span>
                </div>
                <div class="button-container">
                  <i class="icon icon-bin delete-icon reflect" alt="" (keyup.enter)="delete(item)" tabindex="0"
                  (click)="delete(item)" aria-hidden="true"></i>

                <a class="reflect" (keyup.enter)="editMedicalCondition(item)" (click)="editMedicalCondition(item)"
                  tabindex="0" role="button">
                  <span class="linkstyle2">Edit</span>
                </a>
                </div>
              </div>
            </div>
            
            <!-- Repeat the card structure for more items -->
        </div>
                 
        </div>
      
        </ng-container>
      
      <div class="col-md-12">
        <button (click)="addMedicalCondtion()" class="btn ml-30 btn-primary btn-border text-left min-width" type="button"
          id="btn-addMedicalCondition" name="next">{{contentData.buttonText}}
          <i aria-hidden="true" class="icon icon-plus fl-right" alt=""></i>
        </button>
      </div>

      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
            (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
            [tooltipFlag]="true"></app-modal>

      <div class="col-md-12 underline margin-top"></div>
      <div class="col-md-12 clear-all">
        <div class="bottom-container">
          <div class="float-left">
            <app-save *ngIf="!isHOView" [location]="'contentBottom'"></app-save>
          </div>
          <div class="float-right">
            <app-content-bottom-nav (skipBtnHandler)="onSkip()" (onNextHandler)="gotoNextPage()" [checkData]="isDataPresent"
              [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'" 
              [editMode]="(editMode && referenceNumber.isRefreshCard)?false:
              ((editMode && !referenceNumber.isRefreshCard) ? true : false)">
            </app-content-bottom-nav>
          </div>
        </div>
      </div>

      <!-- modal popup-->

      <app-modal *ngIf="isDelete" [modalConfig]="deleteModalConfig" (closeModal)="cancel()"
        (primaryBtnClick)="deleteMedicalCondition()" (secondaryBtnClick)="cancel()" [saveDataFlag]="false"></app-modal>

      <!-- Skip Button Modal Pop-Up -->

      <app-modal *ngIf="isSkip" [modalConfig]="skipModalConfig" (closeModal)="closeSkip()" (primaryBtnClick)="navToAMC()"
        (secondaryBtnClick)="navToDoctorDetails()" [saveDataFlag]="false"></app-modal>

      <!-- Incomplete status model pop-up -->

      <app-modal *ngIf="isIncomplete" [modalConfig]="statusModalConfig" (closeModal)="closeStatusModal()"
        (primaryBtnClick)="closeStatusModal()" [saveDataFlag]="false"></app-modal>

      <!-- edit model pop-up -->

      <app-modal *ngIf="showModalForCardRefresh" [modalConfig]="alertCardRefreshModalConfig"
        (closeModal)="closeCardRefreshModal()" (primaryBtnClick)="alertPrimaryBtnClickinModal()"
        (secondaryBtnClick)="alertSecondaryCardRefreshBtnClick()" [saveDataFlag]="false"></app-modal>

    </form>
  </div>
</div>